<template>


  <div class="cp-usage" v-if="location">
    <report-usages-list :location-id="location?.id" show-no-energy  />
  </div>
</template>

<script>
import ReportUsagesList from "@/components/elements/ReportUsagesList.vue";

export default {
  components: {ReportUsagesList},



  mounted() {

  },



  watch: {

  },

  computed:  {
    location() {
      return this.$parent.location
    },

  },

  methods: {

  }
}
</script>

<style lang="scss">
.cp-usage {

}

</style>
